export const FETCH_ADD_PROJECT_TEMPLATE_REQUEST = 'FETCH_ADD_PROJECT_TEMPLATE_REQUEST'
export const FETCH_ADD_PROJECT_TEMPLATE_SUCCESS = 'FETCH_ADD_PROJECT_TEMPLATE_SUCCESS'
export const FETCH_ADD_PROJECT_TEMPLATE_FALUIRE = 'FETCH_ADD_PROJECT_TEMPLATE_FALUIRE'
export const FETCH_LIST_FORMATTED_PROJECT_TEMPLATE_LIST_SUCCESS='FETCH_LIST_FORMATTED_PROJECT_TEMPLATE_LIST_SUCCESS'
export const CLEAN_ARCHIVE_TYPE = 'CLEAN_ARCHIVE_TYPE'